const enLocale = {
	back: 'Back',
	cancel: 'Cancel',
	close: 'Close',
	collapseAll: 'Collapse All',
	customer: 'Customer',
	disable: 'Disable',
	disabled: 'Disabled',
	enable: 'Enable',
	enabled: 'Enabled',
	expandAll: 'Expand All',
	goBack: 'Go Back',
	hide: 'Hide',
	incomplete: 'Incomplete',
	inProgress: 'In Progress',
	learnMore: 'Learn More',
	logout: 'Log out',
	merchant: 'Merchant',
	next: 'Next',
	takingLongTime: 'Taking a long time...',
	summary: 'Summary',
	date: 'Date',
	today: 'Today',
	yesterday: 'Yesterday',
	last7Days: 'Last 7 days',
	last30Days: 'Last 30 days',
	thisMonth: 'This month',
	lastMonth: 'Last month',
	startDate: 'Start date',
	endDate: 'End date',
	requiredField: 'This field is required',
	'newShiftModal.timeField': 'This time is not valid',
	shiftNotification:
		'Shifts beginning prior to the defined start time will count towards the previous day. This start time is {time}.',
	order: 'Order',
	print: 'Print',
	recommended: 'Recommended',
	setup: 'Setup',
	show: 'Show',
	update: 'Update',
	'welcomeNewCpModal.title': 'Lavu 4',
	'welcomeNewCpModal.subtitle': 'Thank you for using Lavu’s new Control Panel.',
	'welcomeNewCpModal.getStarted': 'Get Started',
	alphaNumericSpacesFieldMsg:
		'This field can only have alphanumeric characters or spaces',
	invalidNumberMsg: 'This is not a valid number',
	numericFieldMsg: 'This field can only have numbers',
	numericFieldMaxMsg: 'This field must be lower than {val}',
	numericFieldMinMsg: 'This field must be greater than {val}',
	requiredFieldMsg: 'This field is required',
	emailFieldMsg: 'This field must be a valid email',
	integerFieldMsg: 'This field should be an integer',
	maxLengthFieldMsg: 'This field can have no more than {max} characters',
	unauthorizedModuleMsg: 'You have not yet been granted access to any modules',
	save: 'Save',
	fieldAdd: 'Add',
	fieldSave: 'Save',
	fieldCancel: 'Cancel',
	contactUs: 'Contact us',
	myAccount: 'My account',
	trialEnded: 'Your trial has ended.',
	trialEndedLavuAdmin: 'The trial period has ended.',
	trialEndedContactUs: 'Please contact us to resume use of Lavu.',
	trialLastDay: 'Today is the last day on your trial.',
	trialEndsInDays:
		'Your trial period ends in {val} {val, plural, one {day} other {days}}.',
	billingToResolveInDays:
		'Your account is past due. You have {val} {val, plural, one {day} other {days}} to resolve this issue.',
	billingToResolveToday:
		'Your account is past due. Today is the last day to resolve this issue.',
	billingGraceEnded: 'Your account has been locked due to a billing issue.',
	billingGraceEndedAdmin: 'This account is past due.',
	notAvailableRecord: 'N/A',
	paginatorOf: 'of',
	allRightsReserved: 'All Rights Reserved',
	somethingWentWrong: 'Sorry, something went wrong.',
	attention: 'Attention',
	stayLoggedIn: 'Stay Logged in',
	terminatingSession: 'Due to inactivity, your session is being terminated',
	inactiveSessionMinutes: `Due to inactivity, your session will be terminated in {minutes} {timeLeft, plural,
		one {minute}
		other {minutes}
	}`,
	inactiveSessionSeconds: `Due to inactivity, your session will be terminated in {minutes} {timeLeft, plural,
		one {second}
		other {seconds}
	}`,
	inactivityLoggedOut: `Due to inactivity, you've been logged out`,
	loading: 'Loading...',
	yes: 'Yes',
	no: 'No',
};

export default enLocale;
